import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { BrandLockup } from "@/shell/CandidateFlow";
import { dpaText } from "./dpaText";

export function Dpa() {
  // Flask 404s /dpa while DPA_ENABLED is off; this covers client-side
  // navigation and case variants the server route does not match.
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    fetch("/api/v1/config", { credentials: "include" })
      .then((r) => r.json())
      .then((d: { dpa_enabled?: boolean }) => setEnabled(d.dpa_enabled === true))
      .catch(() => setEnabled(false));
  }, []);

  if (enabled === null) return null;
  if (!enabled) return <Navigate to="/" replace />;

  return (
    <div style={{ background: "#FBFAFE", minHeight: "100vh", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <header style={{ borderBottom: "1px solid #EFEBF7", padding: "20px 40px", display: "flex", alignItems: "center", gap: 10 }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <BrandLockup />
        </Link>
      </header>
      <main style={{ maxWidth: 680, margin: "0 auto", padding: "60px 24px 80px" }}>
        <div style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" as const, color: "#7A6BE0", marginBottom: 16 }}>
          Data Processing Agreement
        </div>
        <h1 style={{ fontSize: 32, fontWeight: 700, color: "#17131F", marginBottom: 8, letterSpacing: "-0.02em" }}>{dpaText.heading}</h1>
        <p style={{ fontSize: 13, color: "#7C7590", marginBottom: 48 }}>{dpaText.updated}</p>
        {dpaText.sections.map(({ title, body }) => (
          <section key={title} style={{ marginBottom: 36 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, color: "#17131F", marginBottom: 10 }}>{title}</h2>
            <p style={{ fontSize: 15, lineHeight: 1.7, color: "#4A4260" }}>{body}</p>
          </section>
        ))}
      </main>
      <footer style={{ borderTop: "1px solid #EFEBF7", padding: "20px 40px", display: "flex", gap: 20 }}>
        <Link to="/" style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, color: "#7C7590", textDecoration: "none", letterSpacing: "0.06em" }}>Home</Link>
        <Link to="/terms" style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, color: "#7C7590", textDecoration: "none", letterSpacing: "0.06em" }}>Terms of Service</Link>
      </footer>
    </div>
  );
}
